import clientFetcher from '@lib/client-fetcher';
import type { Listing } from 'types/collections';

/**
 * Service for school listing-related operations
 */
export class ListingService {
  /**
   * Get school listing
   */
  async getListing(): Promise<Listing | null> {
    return clientFetcher<Listing>({
      url: '/api/schools/listing',
    });
  }

  /**
   * Get school listing by id
   */
  async getListingById(id: string): Promise<Listing> {
    return clientFetcher<Listing>({
      url: `/api/teacher/listing/${id}`,
    });
  }

  /**
   * Get all school listings
   */
  async getListings(): Promise<Listing[]> {
    return clientFetcher<Listing[]>({
      url: '/api/teacher/listing',
    });
  }

  /**
   * Create a new listing
   */
  async createListing(listingData: {
    intro?: string;
    role?: string;
    rules?: string;
    supplies?: string;
  }): Promise<Listing> {
    return clientFetcher<Listing>({
      url: '/api/schools/listing',
      method: 'POST',
      body: listingData,
    });
  }

  /**
   * Update existing listing
   */
  async updateListing(updates: {
    intro?: string;
    role?: string;
    rules?: string;
    supplies?: string;
    listing_completed?: boolean;
  }): Promise<Listing> {
    return clientFetcher<Listing>({
      url: '/api/schools/listing',
      method: 'PATCH',
      body: updates,
    });
  }
}
